<template>
  <TabsLayout>
    <ElTabPane name="financeRechargeLog" label="充值记录"></ElTabPane>
    <ElTabPane name="financeTransferLog" label="转账记录"></ElTabPane>
  </TabsLayout>
</template>
<script>
import TabsLayout from '@/views/report/tabs-layout.vue'
export default {
  components: { TabsLayout }
}
</script>
<style lang="scss" scoped>
.c-content {
  position: relative;
}
</style>
